import { Col, Row } from '@elotech/components';
import React from 'react';
import { FormGroup } from 'react-bootstrap';

import { ItemFormulario, hoje } from './verificacaoDocumentos';

type Props = {
  itens: ItemFormulario[];
  arquivos: { [documentoId: string]: File };
  onChangeArquivo(documentoId: string, file?: File): void;
  onChangeDado(
    documentoId: string,
    campo: 'numero' | 'emitidoEm',
    valor: string
  ): void;
};

const DocumentosFormulario = ({
  itens,
  arquivos,
  onChangeArquivo,
  onChangeDado
}: Props) => (
  <>
    {itens.map(item => (
      <Row key={item.key}>
        <Col md={item.nivel.possuiNumero || item.nivel.possuiEmitidoEm ? 4 : 8}>
          <FormGroup>
            <label htmlFor={`documento-${item.key}`}>
              {item.nivel.documentoSolicitado}
              {item.nivel.obrigatorio ? (
                ' *'
              ) : (
                <span className="optional">Opcional</span>
              )}
            </label>
            <div className="file-uploader">
              <input
                type="file"
                id={`documento-${item.key}`}
                className="file-uploader-input"
                onChange={e => onChangeArquivo(item.key, e.target.files?.[0])}
                title="Clique ou arraste para anexar"
              />
              <label
                className="input"
                htmlFor={`documento-${item.key}`}
                data-title={
                  arquivos[item.key]?.name || 'Clique ou arraste para anexar'
                }
              />
              <label
                htmlFor={`documento-${item.key}`}
                className="file-uploader-icon"
              />
            </div>
            {item.nivel.descricao && (
              <p className="help-message">{item.nivel.descricao}</p>
            )}
          </FormGroup>
        </Col>
        {item.nivel.possuiNumero && (
          <Col md={4}>
            <FormGroup>
              <label htmlFor={`numero-${item.key}`}>Número</label>
              <input
                id={`numero-${item.key}`}
                type="text"
                maxLength={20}
                className="form-control"
                onChange={e => onChangeDado(item.key, 'numero', e.target.value)}
              />
            </FormGroup>
          </Col>
        )}
        {item.nivel.possuiEmitidoEm && (
          <Col md={4}>
            <FormGroup>
              <label htmlFor={`emitidoem-${item.key}`}>Emitido em</label>
              <input
                id={`emitidoem-${item.key}`}
                type="date"
                max={hoje()}
                className="form-control"
                onChange={e =>
                  onChangeDado(item.key, 'emitidoEm', e.target.value)
                }
              />
            </FormGroup>
          </Col>
        )}
      </Row>
    ))}
  </>
);

export default DocumentosFormulario;
